import { useHasUserCapability } from '@joyful/ui/app'
import { pluralize } from '@joyful/utils'

import { useNeedsResponsePracticeRequestsCount } from '../../requests/hooks/useNeedsResponsePracticeRequestsCount'
import { NavigationItemBadge } from './NavigationItemBadge'

export function PracticeRequestsNavBadge() {
  const hasCapability = useHasUserCapability()
  const { formattedNeedsResponseCount, needsResponseCount } =
    useNeedsResponsePracticeRequestsCount()
  const needsResponseLabel =
    hasCapability('practice_request.view.admin') ||
    hasCapability('practice_request.view.internal')
      ? `Joyful response`
      : `practice response`
  if (needsResponseCount <= 0) {
    return null
  }

  return (
    <NavigationItemBadge
      aria-label={pluralize(
        needsResponseCount,
        `request needing ${needsResponseLabel}`,
        {
          pluralWord: `requests needing ${needsResponseLabel}`,
        },
      )}
    >
      {formattedNeedsResponseCount}
    </NavigationItemBadge>
  )
}
